__turbopack_context__.v({
  "icon": "styles-module__sme23a__icon",
  "list": "styles-module__sme23a__list",
  "nestedLink": "styles-module__sme23a__nestedLink",
});
